export type Environment = {
  apiUrl: string
}
const environment: Environment = {
  apiUrl: process.env.REACT_APP_API_URL ?? 'http://localhost:3001',
}

export default environment
